import React from 'react';

import PlaceholderTab from '~/components/Offers/Detail/OfferBuilder/shared/PlaceholderTab';

import { BLACKOUT_FIELDS } from './fields';

export default function BlackoutsTab() {
  return <PlaceholderTab configuredFieldCount={BLACKOUT_FIELDS.length} title="Blackouts" />;
}
